import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LessonForm from "@/components/lesson/LessonForm.vue";
import Lessons from "@/components/lesson/Lessons.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LessonsPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LessonForm),
    _createVNode(Lessons)
  ], 64))
}
}

})